import { render, staticRenderFns } from "./user_transfer.vue?vue&type=template&id=5ae48f30&scoped=true&"
import script from "./user_transfer.vue?vue&type=script&lang=js&"
export * from "./user_transfer.vue?vue&type=script&lang=js&"
import style0 from "./user_transfer.vue?vue&type=style&index=0&id=5ae48f30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae48f30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae48f30')) {
      api.createRecord('5ae48f30', component.options)
    } else {
      api.reload('5ae48f30', component.options)
    }
    module.hot.accept("./user_transfer.vue?vue&type=template&id=5ae48f30&scoped=true&", function () {
      api.rerender('5ae48f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/user_transfer.vue"
export default component.exports